import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../services/apiservice/apiservice.service';
import { ConfigService } from '../../../services/config/config.service';
import { ApiResponse } from '../../../services/api-response.interface';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../../../services/shared/shared.service';

export interface IEmailCustomerCareRequest {
  toAddress: string;
  messageBody: string;
}

export interface IEmailCustomerCareResponse {
  message: string;
}
export interface SmsCarrier {
  carrierId: number;
  carrierName: string;
  emailGateway: string;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  url = '';

  constructor(
    private _apiService: ApiService,
    private _configService: ConfigService,
    private _http: HttpClient,
    private _sharedService: SharedService,
  ) {}

  SendEmail(data): Observable<any> {
    this.url = this._configService.agApi + '/email/SendEmail';
    return this._apiService.post(this.url, data);
  }

  async sendEmailCustomerCareAsync(data): Promise<IEmailCustomerCareResponse> {
    try {
      this.url = `${this._configService.agApi}/email/customerCare`;
      const response: ApiResponse<IEmailCustomerCareResponse> = await this._http
        .post<ApiResponse<IEmailCustomerCareResponse>>(this.url, data)
        .toPromise();
      if (response) {
        this._sharedService.openSnackBar(response.data.message, 'ok');
        return response.data;
      }
      console.error('failed to send customer care email');
    } catch (error) {
      this._sharedService.openSnackBar(error.message);
      console.error(`error in fn emailService: sendEmailCustomerCareAsync fn  => ${error}`);
    }
    return null;
  }

  /** Gets Active SMS Carriers for user notifications */
  getSmsCarriers(): Observable<SmsCarrier[]> {
    const url = this._configService.agApi + '/email/smsCarriers';
    return this._apiService.get(url);
  }

  /** Sends an SMS message using a selected SMS Carrier (payload) */
  sendSms(data): Observable<any> {
    const url = this._configService.agApi + '/email/SendSms';
    return this._apiService.post(url, data);
  }
}
